import { api } from "./api"

export const linkDocumentService = {
    async getLinkDocument(): Promise<any> {
        const response = await api.get('link-documents');
        return response.data;
    },

    async createLinkDocument(linkDocument: any): Promise<any> {
        const response = await api.post('link-documents', linkDocument);
        return response.data;
    },

    async updateLinkDocument(linkDocument: any): Promise<any> {
        const response = await api.put(`link-documents/${linkDocument.id}`, linkDocument);
        return response.data;
    },

    async deleteLinkDocument(linkDocumentId: string): Promise<void> {
        await api.delete(`link-documents/${linkDocumentId}`);
    }
};